module.exports = __webpack_public_path__ + "img/icon-photographing.15605961.png";